var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ 'font-size': _vm.upperFontSize })},[_vm._v("\n  "+_vm._s(_vm.prefix)+_vm._s(_vm.upperMoney)+"."),_c('span',{style:({ 'font-size': _vm.lowerFontSize, 'color': 'gray' })},[_vm._v(_vm._s(_vm.lowerMoney))])])}
var staticRenderFns = []

export { render, staticRenderFns }